import { inject, Injectable } from '@angular/core';
import {
  CasinoSettingUpdateRTM,
  CountryModeUpdateRTM,
  CurrencyUpdateRTM,
  GlobalRTE,
  RealtimeSubscription,
  StateModeUpdateRTM,
} from '@gains-com/realtime';
import { REALTIME } from './realtime.provider';
import { LOGGER_FACTORY } from '../logger/logger-factory.provider';

import { MetadataViewService } from '../view-states/metadata-view.service.js';
import { CurrenciesViewService } from '../view-states/currencies-view.service.js';
import { DeviceModeViewService } from '../view-states/device-mode-view.service.js';

@Injectable({
  providedIn: 'root',
})
export class GlobalRealtimeChannel {
  private readonly _realtime = inject(REALTIME);
  private readonly _logger = inject(LOGGER_FACTORY).create(
    'GlobalRealtimeHandler'
  );
  private readonly _metadataView = inject(MetadataViewService);
  private readonly _currenciesView = inject(CurrenciesViewService);
  private readonly _deviceModeView = inject(DeviceModeViewService);
  private _subscriptionState: {
    subscription: RealtimeSubscription;
    channel: any;
    onMessageListener: any;
  } | null = null;

  async subscribe() {
    if (this._subscriptionState) {
      this.unsubscribe();
    }

    this._subscriptionState = await this._realtime.createSubscription(
      'global',
      {
        [GlobalRTE.CasinoSettingUpdate]: (request: CasinoSettingUpdateRTM) =>
          this._casinoSettingUpdate(request),
        [GlobalRTE.CurrencyUpdate]: (request: CurrencyUpdateRTM) =>
          this._currencyUpdate(request),
        [GlobalRTE.StateModeUpdate]: (request: StateModeUpdateRTM) =>
          this._stateModeUpdate(request),
        [GlobalRTE.CountryModeUpdate]: (request: CountryModeUpdateRTM) =>
          this._countryModeUpdate(request),
      }
    );

    this._subscriptionState.subscription.subscribe();
  }

  unsubscribe() {
    this._subscriptionState?.subscription?.unsubscribe();
    this._subscriptionState?.subscription.removeListener(
      this._subscriptionState?.onMessageListener
    );
    this._subscriptionState = null;
  }

  private _casinoSettingUpdate(request: CasinoSettingUpdateRTM) {
    this._logger.debug(`GlobalRTM ${GlobalRTE.CasinoSettingUpdate}`, request);
    this._metadataView.updateCasinoSetting(request);
    this._deviceModeView.onCasinoSettingUpdate(request.setting_key);
  }

  private _stateModeUpdate(request: StateModeUpdateRTM) {
    this._logger.debug(`GlobalRTM ${GlobalRTE.StateModeUpdate}`, request);
    this._deviceModeView.updateFromStateModeRtm(request);
  }

  private _countryModeUpdate(request: CountryModeUpdateRTM) {
    this._logger.debug(`GlobalRTM ${GlobalRTE.CountryModeUpdate}`, request);
    this._deviceModeView.updateFromCountryModeRtm(request);
  }

  private _currencyUpdate(request: CurrencyUpdateRTM) {
    this._logger.debug(`GlobalRTM ${GlobalRTE.CurrencyUpdate}`, request);
    this._currenciesView.updateCurrency(request);
  }
}
